// WorkAbroadPage.js
import React from 'react';
import WorkAbroadHero from '../components/WorkAbroad/WorkAbroadHero';
import WorkAbroadIntro from '../components/WorkAbroad/WorkAbroadIntro';
import WhoThisIsFor from '../components/WorkAbroad/WhoThisIsFor';
import EmployerPartnerships from '../components/WorkAbroad/EmployerPartnerships';
import WhatWeSupport from '../components/WorkAbroad/WhatWeSupport';
import ProcessSteps from '../components/WorkAbroad/ProcessSteps';
import TransparencySection from '../components/WorkAbroad/TransparencySection';
import FAQSection from '../components/WorkAbroad/FAQSection';
import CTASection from '../components/WorkAbroad/CTASection';

const WorkAbroadPage = () => {
  return (
    <div>
      <WorkAbroadHero />
      <WorkAbroadIntro />
      <WhoThisIsFor />
      <EmployerPartnerships />
      <WhatWeSupport />
      <ProcessSteps />
      <TransparencySection />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default WorkAbroadPage;
